"use client";

import { useLocale } from "next-intl";
import { useTransition } from "react";
import { usePathname, useRouter } from "@/i18n/navigation";
import { routing } from "@/i18n/routing";

export function LocaleSwitcher() {
	const locale = useLocale();
	const router = useRouter();
	const pathname = usePathname();
	const [isPending, startTransition] = useTransition();

	function switchTo(next: string) {
		if (next === locale) return;
		startTransition(() => {
			router.replace(pathname, { locale: next });
		});
	}

	return (
		<div
			className="inline-flex h-9 items-center rounded-lg border border-border p-0.5 text-sm"
			aria-busy={isPending}
		>
			{routing.locales.map((loc) => (
				<button
					key={loc}
					onClick={() => switchTo(loc)}
					className={`inline-flex h-8 items-center rounded-md px-2.5 transition ${
						loc === locale
							? "bg-surface-2 font-semibold text-text"
							: "text-muted-foreground hover:text-text"
					}`}
				>
					{loc === "ar" ? "ع" : "EN"}
				</button>
			))}
		</div>
	);
}
